export default __webpack_public_path__ + "static/cardstackedmaxdont-e7c0f4cb6914c649f9c7d39f4f71bbe6.png";